/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddManagerRequestBody
 */
export interface AddManagerRequestBody {
    /**
     * The user ID of the user to add as manager
     * @type {string}
     * @memberof AddManagerRequestBody
     */
    managerUserId: string;
}

/**
 * Check if a given object implements the AddManagerRequestBody interface.
 */
export function instanceOfAddManagerRequestBody(value: object): value is AddManagerRequestBody {
    let isInstance = true;
    isInstance = isInstance && "managerUserId" in value && value["managerUserId"] !== undefined;

    return isInstance;
}

export function AddManagerRequestBodyFromJSON(json: any): AddManagerRequestBody {
    return AddManagerRequestBodyFromJSONTyped(json, false);
}

export function AddManagerRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddManagerRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'managerUserId': json['manager_user_id'],
    };
}

export function AddManagerRequestBodyToJSON(value?: AddManagerRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'manager_user_id': value.managerUserId,
    };
}

